import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import logo from "../assets/logo.png";

const Header = function () {
  return (
    <header
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 1,
        backgroundColor: "#0a5a6a",
        color: "fff",
      }}
    >
      <Navbar
        expand="md"
        collapseOnSelect
        style={{
          height: "50px",
          marginTop: "0.2px",
          backgroundColor: "#0a5a6a",
          color: "fff",
        }}
      >
        <Container
          style={{
            marginRight: "8%",
            backgroundColor: "#0a5a6a",
            color: "fff",
          }}
        >
          <LinkContainer to="/">
            <Navbar.Brand>zpotter</Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="ms-auto"
              style={{ backgroundColor: "#0a5a6a", color: "fff" }}
            >
              <LinkContainer to="/home">
                <Nav.Link>Home </Nav.Link>
              </LinkContainer>
              <LinkContainer to="/about">
                <Nav.Link>About Us </Nav.Link>
              </LinkContainer>{" "}
              <LinkContainer to="/services">
                <Nav.Link>Services </Nav.Link>
              </LinkContainer>
              <NavDropdown title="Products">
                <LinkContainer
                  to="/gymSoftware"
                  style={{
                    padding: "0.6rem",
                    borderBottomStyle: "solid",
                    borderColor: "black",
                    borderWidth: "0.5px",
                  }}
                >
                  <NavDropdown.Item>Gym Software</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer
                  to="/housingSoftware"
                  style={{
                    padding: "0.6rem",
                    borderBottomStyle: "solid",
                    borderColor: "black",
                    borderWidth: "0.5px",
                  }}
                >
                  <NavDropdown.Item>Apartment Software</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer
                  to="/restaurentBilling"
                  style={{
                    padding: "0.6rem",

                    borderColor: "black",
                    borderWidth: "0.5px",
                  }}
                >
                  <NavDropdown.Item>
                    Restaurent Billing Software
                  </NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>
              <LinkContainer to="/contact">
                <Nav.Link>Contact Us </Nav.Link>
              </LinkContainer>
              {/* <Nav.Link
                href="https://mygym.zpotter.in/login"
                rel="noopener noreferrer"
              >
                Login
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
